<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Coupons",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Coupons",
            items: [
               {
                  text: "Coupons",
                  active: true,
               },                   
            ],

            

            coupons: [],
            coupon: {
               id: null,
                name : "",
                  code: "",
                  type: 0,
                  coupon_type: 0,
                  amount: '',
                  percentage: '',
                  count: "",
                  expiry: "",
            },
            
            modal_title: "Add Coupon",
            button_title: "Save",
            pagination: {},
            edit: false,
            coupon_status: {
               id: "",
               status: "",
            },
            listing_length: 10,
            keyword: '',
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
         };
      },
      mounted() {
    
      },

      methods: {
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         editCoupon() {          
            this.modal_title = "Edit Coupon";
            this.button_title = "Update";
            this.coupon.name = "Coupon 1";
            this.coupon.code = "A123ZY";
            this.coupon.type = 0;
            this.coupon.coupon_type = 0;
            this.coupon.amount = 20;
            this.coupon.percentage = '';
            this.coupon.count = "25";
            this.coupon.expiry = "2022-04-20";
            this.edit = true;
            this.showModal("coupon-modal");
         },
         clearForm() {           
            
            this.modal_title = "Add Coupon";
            this.button_title = "Add";
            this.coupon.name = "";
            this.coupon.code = "";
            this.coupon.type = 0;
            this.coupon.coupon_type = 0;
            this.coupon.amount = '';
            this.coupon.percentage = '';
            this.coupon.count = "";
            this.coupon.expiry = "";
            this.edit = false;
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.coupon-modal variant="primary" class="float-end">Add Coupon</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"/>
                           </label>
                        </div>                     
                        <!-- <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status">
                                 <option :value="null">All</option>
                                 <option value="1">Published</option>
                                 <option value="0">Unpublished</option>
                              </select>
                           </label>
                        </div>    -->
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th width="10%">Name</th>  
                              <th width="10%">Code</th>  
                              <th width="10%">Count</th> 
                              <th width="10%">Expiry</th>      
                              <th width="15%">Created On</th>
                              <th width="10%">Options</th>                             
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td>Coupon 1</td>
                              <td>A123ZY</td>
                              <td>25</td>
                              <td>20 Apr 2022</td>
                              <td>11 Nov 2021, 04:25 pm</td>
                              <td>
                                 <b-button variant="primary" class="btn-sm me-2 mb-2" @click="editCoupon">Edit</b-button>                         
                                 <b-button variant="danger" class="btn-sm me-2 mb-2" >Unpublish</b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption class="float-start mt-4 d-block d-lg-inline">Showing 1 to 10 of 26 entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item disabled">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-left"></i>
                        </a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">1</a>
                     </li>
                     <li class="page-item active">
                        <a href="#" class="page-link">2</a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">3</a>
                     </li>
                     
                     <li class="page-item">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-right"></i>
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="coupon-modal" id="coupon-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form>
                        <b-row>
                           <b-col md="12" class="form-group">
                              <label class="control-label">Name<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col> 

                           <b-col md="12" class="form-group">
                              <label class="control-label">Coupon for<span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="coupon.coupon_type">
                                 <div class="form-check-inline">
                                    <b-form-radio :name="coupon_for"  :value="0">Pharmacy Orders</b-form-radio> 
                                 </div>  
                                 <div class="form-check-inline">
                                    <b-form-radio :name="coupon_for" :value="1">Video Consultation</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                           </b-col>    


                           <b-col md="12" class="form-group">
                              <label class="control-label">Type<span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="coupon.type">
                                 <div class="form-check-inline">
                                    <b-form-radio :name="coupon_type"  :value="0">Amount</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline"> 
                                    <b-form-radio :name="coupon_type" :value="1">Percentage</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                           </b-col>

                           <b-col md="6" class="form-group">
                              <label class="control-label">Code<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.code" v-bind:class="{ 'is-invalid': Boolean(errors.code) }"></b-form-input>
                              <div v-for="(val, index) in errors.code" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group" v-if="coupon.type==0">
                              <label class="control-label">Amount (in Rs)<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.amount" v-bind:class="{ 'is-invalid': Boolean(errors.amount) }"></b-form-input>
                              <div v-for="(val, index) in errors.amount" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group" v-if="coupon.type==1">
                              <label class="control-label">Percentage<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.percentage" v-bind:class="{ 'is-invalid': Boolean(errors.percentage) }"></b-form-input>
                              <div v-for="(val, index) in errors.percentage" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group">
                              <label class="control-label">Count<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.count" v-bind:class="{ 'is-invalid': Boolean(errors.count) }"></b-form-input>
                              <div v-for="(val, index) in errors.count" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group">
                              <label class="control-label">Expiry<span class="text-danger">*</span></label>
                              <!-- <b-form-datepicker v-model="coupon.expiry" v-bind:class="{ 'is-invalid': Boolean(errors.expiry) }"></b-form-datepicker> -->
                              <input type="date" class="form-control" />
                              <div v-for="(val, index) in errors.expiry" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           
                           <b-col md="12">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('coupon-modal')">Close</b-button>
                           </b-col>
                        </b-row>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
